<div class="row toke-line">
  <div class="col-md-12">
    <img [src]="result">
  </div>
</div>
